import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { AuthService } from '../../../../services/auth.service';
import { TranslateService } from '@ngx-translate/core';
import { ConfigService } from '../../../../services/config.service';

@Component({
    selector: 'app-navigation',
    templateUrl: './navigation.component.html',
    styleUrls: ['./navigation.component.scss'],
})
export class NavigationComponent implements OnInit {
    @Input() appName = 'Account';
    @Input() showSecondBar = true;
    showBanner = false;
    bannerStartDate: Date = null;
    bannerEndDate: Date = null;
    bannerIcon = null;
    bannerDescription = null;

    @Output() menuButtonClick = new EventEmitter();

    constructor(
        public auth: AuthService,
        public translateService: TranslateService,
        public configService: ConfigService,
    ) {}

    ngOnInit() {
        this.getBanner();
        this.translateService.onLangChange.subscribe(() => this.getBanner());
    }

    getBanner() {
        // Determine if we have a message to show
        const now = new Date();
        this.translateService.get('INFORMATION_BANNER.START_DATE').subscribe((s: string) => {
            this.bannerStartDate = new Date(s);
        });
        this.translateService.get('INFORMATION_BANNER.END_DATE').subscribe((s: string) => {
            this.bannerEndDate = new Date(s);
        });
        // Check if the current date is between maintenanceMessageStartDate and maintenanceMessageEndDate
        if (this.bannerStartDate < now && now < this.bannerEndDate) {
            this.showBanner = true;

            this.translateService.get('INFORMATION_BANNER.ICON').subscribe((s: string) => {
                this.bannerIcon = s;
            });
            this.translateService.get('INFORMATION_BANNER.DESCRIPTION').subscribe((s: string) => {
                this.bannerDescription = s;
            });
        }
    }

    menuButtonPressed() {
        this.menuButtonClick.emit();
    }
}
